import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('audio-item');
export const AudioItem = ({ title, onClick, isPlaying, ...props }) => {
    const iconName = isPlaying ? 'pause' : 'play';
    return <div className={ block() } onClick={ onClick }>
        <Text>{ title }</Text>
        <div className={el('icon')}>
            <Icon name={ iconName }/>
        </div>
    </div>
}
